// import {query} from 'api';
import HomepageRecette from './homepageRecette';
import {Container, Slides} from './styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';
import {Button, colors, MainTitle, SmallTitle} from 'ui';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  // slidesToShow: 1,
  // slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
};

const HomepageRecettes = ({posts}) => (
  <Container>
    <SmallTitle>C’est tendance</SmallTitle>
    <MainTitle
      style={{
        color: colors.black,
      }}>
      Recettes & Gestes techniques
    </MainTitle>
    <Slides {...settings}>
      {posts.map(({id, type}) => (
        <HomepageRecette key={`${id}${type}`} type={type} id={id} />
      ))}
    </Slides>
    <Button style={{margin: 'auto'}} to="/recipes">
      Voir plus
    </Button>
  </Container>
);

HomepageRecettes.propTypes = {
  posts: PropTypes.array.isRequired,
};

export default HomepageRecettes;
